export default __webpack_public_path__ + "static/media/angelita_logo.f5977942.png";